import { queryOptions } from "@tanstack/react-query";
import { GET_USER_INF_FOR_WEB, LST_PBIMG } from "~/constants/apiEndpoints";
import { apiClient } from "~/lib/apiClient";
import { queryKeys } from "~/lib/queryKeys";
import { useAuthStore } from "~/stores/useAuthStore";
import { useDebugStore } from "~/stores/useDebugStore";
import { API_ERROR_CODES, ApiError } from "~/types/api";
import type { PublicImage, UserProfile } from "~/types/userProfile";

// サーバ仕様: user_id = 自分（ログイン中ユーザー）、req_user_id = 対象ユーザー
// 本人確認済み（is_identified）もこのレスポンスに含まれる
export const userProfileQueryOptions = (userId: string) =>
  queryOptions({
    queryKey: queryKeys.user.profile(userId),
    queryFn: () => {
      // デバッグパネルからcode:60(ブロック)エラーを再現するためのフック
      if (useDebugStore.getState().forceBlockedProfileError) {
        throw new ApiError(
          API_ERROR_CODES.BLOCK_USER,
          "debug: forced block error",
        );
      }
      // デバッグパネルから未対応コードのエラー(汎用エラーモーダル表示)を再現するためのフック
      if (useDebugStore.getState().forceUnknownProfileError) {
        throw new ApiError(9999, "debug: forced unknown error");
      }
      return apiClient<UserProfile>(GET_USER_INF_FOR_WEB, {
        user_id: useAuthStore.getState().userId,
        req_user_id: userId,
      });
    },
  });

// lst_pbimg は req_user_id に「対象ユーザーID」を渡す iOS 仕様に合わせる
export const publicImagesQueryOptions = (userId: string) =>
  queryOptions({
    queryKey: queryKeys.user.publicImages(userId),
    queryFn: () =>
      apiClient<PublicImage[]>(LST_PBIMG, {
        req_user_id: userId,
        skip: 0,
        take: 50,
      }),
  });
